/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Studio_FailedInputs */

const en_landing_studio_failed = /** @type {(inputs: Landing_Studio_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Generation failed. Your credits were refunded.`)
};

const zh_landing_studio_failed = /** @type {(inputs: Landing_Studio_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`生成失败，积分已自动退回。`)
};

/**
* | output |
* | --- |
* | "Generation failed. Your credits were refunded." |
*
* @param {Landing_Studio_FailedInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const landing_studio_failed = /** @type {((inputs?: Landing_Studio_FailedInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Studio_FailedInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_landing_studio_failed(inputs)
	return zh_landing_studio_failed(inputs)
});
export { landing_studio_failed as "landing.studio.failed" }